import './transitionKeyframes.css';
var transitionOptionStyles = [{
  type: 'fadeInFadeOut',
  initial: {
    transition: "opacity 500ms ease-in-out",
    opacity: 0
  },
  transition: {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  },
  timeout: {
    exit: 500
  }
}, {
  type: 'fadeInSwipeLeft',
  initial: {
    transition: "opacity 500ms ease-in-out",
    opacity: 0
  },
  transition: {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1
    },
    exiting: {
      animationName: 'deleteItem',
      animationFillMode: 'both',
      animationDuration: '750ms',
      opacity: 1
    },
    exited: {
      opacity: 0
    }
  },
  timeout: {
    exit: 750
  }
}, {
  type: 'shakeInFadeOut',
  initial: {
    transition: "opacity 500ms ease-in-out",
    opacity: 1
  },
  transition: {
    entering: {
      opacity: 1
    },
    entered: {
      animationName: 'shakeIn',
      animationFillMode: 'both',
      animationDuration: '750ms',
      opacity: 1
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  },
  timeout: {
    exit: 750
  }
}];
export default transitionOptionStyles;